<div class="container" style="border: none !important" *ngIf="show === false">
  <h2>Acceso denegado</h2>
</div>
<div
  class="container"
  style="border: none !important"
  *ngIf="show === true && validate === false"
>
  <h2>Acceso denegado</h2>
</div>
<section id="login" *ngIf="show && validate">
  <div class="row full-height-vh m-0">
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="fondo-login d-flex align-items-center justify-content-center">
        <div class="card overflow-hidden">
          <div class="card-content">
            <div class="card-body">
              <div class="row m-0">
                <div class="col-12 justify-content-center align-items-center">
                  <img
                    src="assets/img/logo.png"
                    alt=""
                    class="img-fluid logo-login"
                    width="250"
                  />

                  <h4 class="text-center mt-2 text-white">
                    Restablecer Contraseña
                  </h4>
                  <p style="color: white; text-align: center">
                    Utilice el siguiente formulario para <br />
                    cambiar la contraseña por defecto o<br />para cambiar su
                    contraseña actual.
                  </p>
                  <form
                    autocomplete="off"
                    [formGroup]="user"
                    (ngSubmit)="guardar()"
                  >
                    <div class="form-group">
                      <div class="input-group">
                        <input
                          class="form-control"
                          [type]="fieldTextType ? 'text' : 'password'"
                          placeholder="Contraseña"
                          formControlName="password"
                          [class.is-invalid]="pass1NoValido"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <i
                              class="fa"
                              [ngClass]="{
                                'fa-eye-slash': !fieldTextType,
                                'fa-eye': fieldTextType
                              }"
                              (click)="toggleFieldTextType()"
                            ></i>
                          </span>
                        </div>
                      </div>
                      <small *ngIf="pass1NoValido" class="text-white text-left">
                        Debe contener al menos 6 caracteres.
                      </small>
                    </div>

                    <div class="form-group">
                      <div class="input-group">
                        <input
                          class="form-control"
                          [type]="fieldTextType2 ? 'text' : 'password'"
                          placeholder="Repite Contraseña"
                          formControlName="password2"
                          [class.is-invalid]="pass2NoValido"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <i
                              class="fa"
                              [ngClass]="{
                                'fa-eye-slash': !fieldTextType2,
                                'fa-eye': fieldTextType2
                              }"
                              (click)="toggleFieldTextType2()"
                            ></i>
                          </span>
                        </div>
                      </div>
                      <small *ngIf="pass2NoValido" class="text-white text-left">
                        Las contraseñas no son iguales
                      </small>
                    </div>

                    <div class="form-group row">
                      <div class="input-group">
                        <button
                          type="submit"
                          [disabled]="!user.valid"
                          class="btn btn-secondary btn-block"
                        >
                          Aceptar
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="card-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer class="container-fluid"></app-footer>
</section>
<div
  *ngIf="spinner"
  class="spinner swal2-container swal2-center swal2-backdrop-show"
>
  <img class="spinner-img" src="../../../assets/img/logo-empresa.png" />
</div>
